export const NEWS_DEFAULT = [
    {
        id: 0,
        title: "Scanning global news... (click to refresh)",
        url: "",
    },
]

export const NEWS_ERROR = [
    {
        id: 0,
        title: "We are unable to find any relevant safety-related news yet, but keep watching this space for any changes.",
        url: "",
    },
]

export const TOAST_ENTITY_UNKNOWN =
    "We were unable to find sufficient data for the place you were exploring.<br></br> <br></br>We're on it though and are already performing a deeper analysis to get the data for you. <br></br> <br></br> Please try again later."
